import http from "./http-common";
import { coalesceAsync } from "../../utilities/coalesceAsync";

const getAll = (opts = {}) => {
  const params = opts?.params || {};
  const key = `get-statistics:${JSON.stringify(params)}`;
  return coalesceAsync(key, () => http.get("/get-statistics", opts));
};

const StatsService = {
  getAll
};

export default StatsService;
